export default __webpack_public_path__ + "media/images/lp/About-pc-9a9f6f3cf26d0456589e97c2f01de476.jpg";